import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home } from 'lucide-react';

export default function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div className="page-404">
      <div>
        <div style={{ fontSize: 80, marginBottom: 16, lineHeight: 1 }}>404</div>
        <h1 style={{ fontSize: 28, fontWeight: 800, marginBottom: 8 }}>Halaman Tidak Ditemukan</h1>
        <p style={{ color: 'var(--gray-500)', marginBottom: 28, fontSize: 15 }}>
          Halaman yang Anda cari tidak ada atau telah dipindahkan.
        </p>
        <button className="btn btn-primary btn-lg" onClick={() => navigate('/')}>
          <Home size={18} /> Kembali ke Dashboard
        </button>
      </div>
    </div>
  );
}
